// extracted by mini-css-extract-plugin
export default {"hero":"styles_hero__IwA-d","heroBox":"styles_heroBox__HgfI2","heroBoxElement":"styles_heroBoxElement__vqzJW","icon":"styles_icon__rbHg+","button":"styles_button__C-z0i"};